import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as irActions from '../../../redux/actions/irSearchActions';

import FilersCases from './FilersCases';

const type = 'filers';
const noDataFoundMessage = 'No parties have filed anything for this case';

export class FilersCasesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: '',
    };
  }
  componentDidMount() {
    if (this.props.purchase_right_away) { this.purchaseData(); } else { this.getData(); }
  }

    getData = () => {
      this.props.dispatch(irActions.getCaseData({
        type,
        case_uuid: this.props.case_uuid,
      }));
    }

  purchaseData = () => {
    this.props.dispatch(irActions.purchaseCaseData({
      type,
      case_uuid: this.props.case_uuid,
    }));
  }

  changeFilter = (e, name) => {
    this.setState({ [name]: e.target.value });
  }

  onClear = () => {
    const state = {
      keyword: '',
    };

    this.setState({keyword: ''});
  }

  render() {
    const filersProps = {
      keyword: this.state.keyword,
      onChange: this.changeFilter,
      onClear: this.onClear,
    };
    return (
      <FilersCases
        {...this.props}
        type={type}
        filersProps={filersProps}
        keyword={this.state.keyword}
        purchaseData={this.purchaseData}
        noDataFoundMessage={noDataFoundMessage}
      />
    );
  }
}

FilersCasesContainer.defaultProps = {
  purchase_right_away: false,
  error: null,
  receipt: null,
};

FilersCasesContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  filers: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const irSearch = state.get('irSearch').toJS();
  return {
    dataReady: irSearch.data_ready,
    filers: irSearch.data,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(FilersCasesContainer);



// WEBPACK FOOTER //
// ./src/components/case/filers/FilersCasesContainer.js